import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const MarketPricePage: React.FC = () => {
  const [symbol, setSymbol] = useState('');
  const [exchange, setExchange] = useState('NSE');
  const [price, setPrice] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getStockPrice = async () => {
    if (!symbol) {
      setError('Please enter a stock symbol.');
      return;
    }
    setLoading(true);
    setError(null);
    setPrice(null);

    try {
      const getStockPriceFunction = httpsCallable(functions, 'getStockPrice');
      const result = await getStockPriceFunction({ symbol, exchange });
      setPrice(result.data);
    } catch (err: any) { 
      setError(err.message || 'Failed to fetch stock price.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <h2 className="text-center mb-4">Live Market Price</h2>
      <Card className="p-4 shadow-sm">
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Stock Symbol</Form.Label>
            <Form.Control
              type="text"
              value={symbol}
              onChange={(e) => setSymbol(e.target.value.toUpperCase())}
              placeholder="e.g., RELIANCE or 500325"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Exchange</Form.Label>
            <Form.Select value={exchange} onChange={(e) => setExchange(e.target.value)}>
              <option value="NSE">NSE</option>
              <option value="BSE">BSE</option>
            </Form.Select>
          </Form.Group>

          <Button variant="primary" onClick={getStockPrice} disabled={loading}>
            {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Get Price'}
          </Button>
        </Form>
      </Card>

      {error && <Alert variant="danger" className="mt-4">{error}</Alert>}

      {price && (
        <Card className="mt-4">
          <Card.Body>
            <Card.Title>{price.price.companyName} ({price.price.symbol})</Card.Title>
            <Card.Text>
              <strong>Last Price:</strong> {price.price.lastPrice} <br />
              <strong>Change:</strong> {price.price.change} ({price.price.pChange}%) <br />
              <strong>High:</strong> {price.price.high} <br />
              <strong>Low:</strong> {price.price.low} <br />
              <strong>Last Updated:</strong> {price.price.lastUpdateTime}
            </Card.Text>
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default MarketPricePage;
